
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

const BuyerLandingCTA = () => {
  const { ref, isVisible } = useScrollAnimation<HTMLElement>();

  return (
    <section ref={ref} className="py-20 px-4">
      <div className="container mx-auto text-center max-w-3xl">
        <div className={`transition-all duration-700 ${isVisible ? 'animate-scale-in' : 'opacity-0 scale-95'}`}>
          <h2 className="text-4xl font-bold mb-6">
            Ready to Find Your Next Investment?
          </h2>
          <p className="text-xl text-gray-300 mb-8">
            Join thousands of investors who are already using GoDyspo to discover 
            and secure profitable real estate deals.
          </p>
          <Link to="/buyer/register">
            <Button size="lg" className="bg-[#ffd700] text-[#080c14] hover:bg-[#e6c200] px-8 hover-lift group">
              Get Started - Free
              <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
            </Button>
          </Link>
          <p className="text-sm text-gray-400 mt-4">
            No setup fees • Cancel anytime • Join in 2 minutes
          </p>
        </div>
      </div>
    </section>
  );
};

export default BuyerLandingCTA;
